/** Limits and validation for English lemma input when adding words manually. */
export const wordInputLimits = {
  minLength: 2,
  maxLength: 50,
} as const

/** Single English word: letters with optional internal hyphen or apostrophe. */
export const englishWordPattern = /^[A-Za-z]+(?:[-'][A-Za-z]+)*$/

/** Typographic apostrophes and unicode dashes → ASCII for validation and API. */
export function normalizeEnglishWord(value: string): string {
  return value
    .trim()
    .replace(/[\u2018\u2019\u02BC`]/g, "'")
    .replace(/[\u2010-\u2014]/g, '-')
}

export function sanitizeEnglishWordInput(value: string): string {
  return normalizeEnglishWord(value.replace(/[^A-Za-z\u2018\u2019\u02BC'`\-]/g, '')).slice(
    0,
    wordInputLimits.maxLength
  )
}

export function isValidEnglishWord(value: string): boolean {
  const normalized = normalizeEnglishWord(value)
  return (
    normalized.length >= wordInputLimits.minLength &&
    normalized.length <= wordInputLimits.maxLength &&
    englishWordPattern.test(normalized)
  )
}
